import { FC, Fragment } from 'react';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { Button } from './Buttons';
import PrizesDialog from 'dialogs/Prizes.dialog';
// Icons
import { FaStar } from "react-icons/fa";
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  prizes: string[];
}

const Prizes:FC<Props> = ({ prizes }) => {
  const { t } = useTranslation('common');

  const { open, toggle } = useToggle();

  if ( !prizes.length ) return null;
  return (
    <Fragment>
      {open ? <PrizesDialog onClose={toggle} prizes={prizes} /> : null}
      <Button
        className="
          w-10/12 mx-auto mb-4 flex items-center justify-between font-bold !text-xl
          bg-gradient-to-b from-[#97bf50] to-[#c2ca42] hover:from-[#c2ca42] hover:to-[#97bf50]
        "
        onClick={toggle}
      >
        <FaStar className="text-white text-xl ml-2" />
          {t('components.prizes.viewPrizes')}
        <FaStar className="text-white text-xl mr-2" />
      </Button>
    </Fragment>
  )
}

export default Prizes;
